export const users = [
  {
    name: "TESTER_1 (1471)",
    token:
      "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIrOTcyMDUyNDU2ODg5MCIsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdLCJjbGllbnRfaWQiOjE0NzEsImlhdCI6MTY2MTY5ODU2OCwiZXhwIjoxNjY5NTg3Nzk5LCJpc3MiOiJQYXN0aW1lTGl2ZSJ9.-qJJBtIkm7j6wkQc6x8jtrWxJ4m7txO97uulxzug_WUn5Cw8jynKQD_vDWWS5w35L3kLCl2avvi5LP138zc0RQ",
  },
  {
    name: "TESTER_2 (1472)",
    token:
      "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIrMTIzNDIzNDIzNDIiLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiXSwiY2xpZW50X2lkIjoxNDcyLCJpYXQiOjE2NjE2OTg1NjgsImV4cCI6MTY2OTU4Nzc5OSwiaXNzIjoiUGFzdGltZUxpdmUifQ.fhfDCQpQvRR8IJ9Px0blrvXwScr3GLH6xXhxJe-uNqzVC4T1S1SNoBQgoIH3BOV5iQEkZPCH3RqFrHi7slO-5A",
  },
  {
    name: "TESTER_3 (1473)",
    token:
      "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIrMTU0ODkwMDk3NjkiLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiXSwiY2xpZW50X2lkIjoxNDczLCJpYXQiOjE2NjE2OTg1NjksImV4cCI6MTY2OTU4NzgwMCwiaXNzIjoiUGFzdGltZUxpdmUifQ.bZ0AyK5UateJp9u2iHR84RMAR-NIDr8xsqljWBgPNqoj0M7Ui7m6Wv40x9gZqmo_g6E0oZd9DOukGt7sxlhU6w",
  },
  {
    name: "TESTER_4 (1474)",
    token:
      "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIrOTcyMDUyNDU2ODg5MCIsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdLCJjbGllbnRfaWQiOjE0NzQsImlhdCI6MTY2MTY5ODU3MCwiZXhwIjoxNjY5NTg3ODAxLCJpc3MiOiJQYXN0aW1lTGl2ZSJ9.ifwUCtIu6wC0fLVJXAGDlNY7Hi6BP5Qm5bnKuQEvbn7QrJVHtZEJ16l4x8icfXwJVGeu7X0DCW1oAN1K3xQY5Q",
  },
  {
    name: "TESTER_5 (1475)",
    token:
      "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIrOTcyMDUyMzU2Nzc4OSIsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdLCJjbGllbnRfaWQiOjE0NzUsImlhdCI6MTY2MTY5ODU3MSwiZXhwIjoxNjY5NTg3ODAyLCJpc3MiOiJQYXN0aW1lTGl2ZSJ9.4TKP1E_Ws_GxAlAtTM7vE76k56eIRF_QGpIwMoWXldZGSdSXdqSrwZjrxa48b2lznXEmfgo5IDxkFddLYDSSdQ",
  },
  {
    name: "TESTER_6 (1476)",
    token:
      "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIrOTcyMDU3MjI1NTY0NSIsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdLCJjbGllbnRfaWQiOjE0NzYsImlhdCI6MTY2MTY5ODU3MiwiZXhwIjoxNjY5NTg3ODAzLCJpc3MiOiJQYXN0aW1lTGl2ZSJ9.lfH6j0-rqrfVtfy3oGEyvpkmgH8CLD-MYW76pnbdQdt98ecAo3Moe0FGdHufu6_6BUYQNX0woax2axVCccx0qw",
  },
  {
    name: "Admin",
    token:
      "eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX0FETUlOIl0sImNsaWVudF9pZCI6MTU4NiwiaWF0IjoxNjQ2MzA1NDEyLCJleHAiOjE2NDYzOTE4MTIsImlzcyI6IlBhc3RpbWVMaXZlIn0.wTZB8p_C5tjCLjbRDkenBS1F_pqxEnlWPzMYgOC5PloynK1KFnaBKv-HPgDg2NMzXy01zJXs4kIFJ2XWIRkopg",
  },
];
